import React from 'react';

import { Popup } from 'src/components/Popup/Popup';
import Tabs from 'src/components/Tabs/Tabs';
import SportGeneral from './SportGeneral';
import { SportCompetitions } from './SportCompetitions/SportCompetitions';
import { SportGrades } from 'src/components/SportPopup/SportGrades/SportGrades';
import Participants from './Participants';

import { MarketFilters } from './MarketFilters/MarketFilters';
import { observer } from 'src/utils/mobx-react';
import { SportMarketTemplates } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates';
import { useAppStateContext } from 'src/AppState/AppState';
import { MobxMapSportGradesState, SportGradesState } from './SportGrades/SportGradesState';

const INVISIBLE_CHARACTER = String.fromCharCode(8205);

class SportState {
    private readonly sportGradesState: MobxMapSportGradesState;

    public constructor() {
        this.sportGradesState = new MobxMapSportGradesState();
    }

    public getSportGrades(sportId: string): SportGradesState {
        return this.sportGradesState.get(sportId);
    }
}

interface PropsType {
    id: string | undefined | null;
    onClose: () => void;
}

export const SportPopup = observer('SportPopup', (props: PropsType): JSX.Element | null => {
    const appState = useAppStateContext();
    const [sportState] = React.useState(() => new SportState());
    const { onClose, id } = props;

    if (id === undefined || id === null) {
        return null;
    }

    const sportModel = appState.sdkStaff.models.getSport(id);
    const sportName = sportModel?.name ?? INVISIBLE_CHARACTER;

    return (
        <Popup
            title={sportName}
            className='sport-popup'
            onClose={onClose}
        >
            <Tabs className='tabs__vertical'>
                <SportGeneral
                    key='general'
                    label='General'
                    sportId={id}
                />
                <SportGrades
                    key='grades'
                    label='Grades'
                    sportGradesState={sportState.getSportGrades(id)}
                />

                <SportCompetitions
                    key='competitions'
                    label='Competitions'
                    sportId={id}
                />

                <MarketFilters
                    key='market-filters'
                    label='Market Filters'
                    sportId={id}
                />

                <SportMarketTemplates
                    key='market-templates'
                    label='Market templates'
                    sportId={id}
                />

                <Participants
                    key='sport-participants'
                    label='Participants'
                    sportId={id}
                />
            </Tabs>
        </Popup>
    );
});
